import { render, staticRenderFns } from "./TipoBaixaForm.vue?vue&type=template&id=582d12b9"
import script from "./TipoBaixaForm.vue?vue&type=script&lang=js"
export * from "./TipoBaixaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports